import React from 'react';
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, TextField } from '@biq/apex-ui';
import {
    PairedInputSelectionProps,
    pairedInputSelectionStyles,
} from './paired-input-selection-helper';

export const PairedInputSelection = ({
    onAttributeAssociationChanged,
    attributeAssociationItem,
    leftSideInputLabel,
    rightSideInputLabel,
    leftSideInputStyles,
    rightSideInputStyles,
    customInputSelectionStyles,
    deleteButtonContainerStyles,
    deleteButtonStyles,
    emptyErrorMessage,
    handleRemove,
}: PairedInputSelectionProps): React.JSX.Element => {
    const handleLeftSideChange = (newValue: string): void => {
        onAttributeAssociationChanged({
            ...attributeAssociationItem,
            attributeAssociation: {
                ...attributeAssociationItem.attributeAssociation,
                leftSideValue: newValue,
            },
            leftSideError: !newValue,
            leftSideErrorMessage: newValue ? emptyErrorMessage : '',
        });
    };

    const handleRightSideChange = (newValue: string): void => {
        onAttributeAssociationChanged({
            ...attributeAssociationItem,
            attributeAssociation: {
                ...attributeAssociationItem.attributeAssociation,
                rightSideValue: newValue,
            },
            rightSideError: !newValue,
            rightSideErrorMessage: newValue ? emptyErrorMessage : '',
        });
    };

    return (
        <Grid sx={customInputSelectionStyles}>
            <Grid sx={pairedInputSelectionStyles.associationLeftSideContainer}>
                <TextField
                    variant='outlined'
                    label={leftSideInputLabel}
                    value={
                        attributeAssociationItem.attributeAssociation
                            .leftSideValue
                    }
                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                        handleLeftSideChange(e.target.value)
                    }
                    errorText={attributeAssociationItem.leftSideErrorMessage}
                    error={attributeAssociationItem.leftSideError}
                    style={leftSideInputStyles}
                />
            </Grid>
            <Grid sx={pairedInputSelectionStyles.associationRightSideContainer}>
                <TextField
                    variant='outlined'
                    label={rightSideInputLabel}
                    value={
                        attributeAssociationItem.attributeAssociation
                            .rightSideValue
                    }
                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                        handleRightSideChange(e.target.value)
                    }
                    errorText={attributeAssociationItem.rightSideErrorMessage}
                    error={attributeAssociationItem.rightSideError}
                    style={rightSideInputStyles}
                />
            </Grid>
            <Grid sx={deleteButtonContainerStyles}>
                <IconButton
                    color='grayalt'
                    size='small'
                    buttonType='closeButton'
                    onClick={handleRemove}
                    sx={deleteButtonStyles}
                >
                    <CloseIcon />
                </IconButton>
            </Grid>
        </Grid>
    );
};
